var map = {
	"./bien-fit-controller.js": 3033,
	"./favorite-controller.js": 6549,
	"./games/agree-disagree-controller.js": 556,
	"./games/approve-reject-controller.js": 7916,
	"./games/choose-one-controller.js": 3981,
	"./games/completion-controller.js": 7799,
	"./games/week2-timer-controller.js": 5,
	"./games/week3-controller.js": 3192,
	"./games/week4-controller.js": 7615,
	"./games/week5-controller.js": 8866,
	"./games/week6-controller.js": 1985,
	"./games/week7-controller.js": 2188,
	"./mdc/slider-controller.js": 5939,
	"./my-progreso-controller.js": 4941,
	"./parent-radio-controller.js": 2795,
	"./recording-controller.js": 8878,
	"./video-events-controller.js": 9904,
	"entrypoints/controllers/bien-fit-controller.js": 3033,
	"entrypoints/controllers/favorite-controller.js": 6549,
	"entrypoints/controllers/games/agree-disagree-controller.js": 556,
	"entrypoints/controllers/games/approve-reject-controller.js": 7916,
	"entrypoints/controllers/games/choose-one-controller.js": 3981,
	"entrypoints/controllers/games/completion-controller.js": 7799,
	"entrypoints/controllers/games/week2-timer-controller.js": 5,
	"entrypoints/controllers/games/week3-controller.js": 3192,
	"entrypoints/controllers/games/week4-controller.js": 7615,
	"entrypoints/controllers/games/week5-controller.js": 8866,
	"entrypoints/controllers/games/week6-controller.js": 1985,
	"entrypoints/controllers/games/week7-controller.js": 2188,
	"entrypoints/controllers/mdc/slider-controller.js": 5939,
	"entrypoints/controllers/my-progreso-controller.js": 4941,
	"entrypoints/controllers/parent-radio-controller.js": 2795,
	"entrypoints/controllers/recording-controller.js": 8878,
	"entrypoints/controllers/video-events-controller.js": 9904
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 256;